import { render, staticRenderFns } from "./ProjectFormNavWrapper.vue?vue&type=template&id=fe8ebe54"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports